/* eslint-disable @next/next/no-img-element -- static sidenav SVG; Next Image breaks local SVG sizing */
import { getImage } from '@utils/imageHelper';

const REFER_EARN_ICON_SRC = getImage('referrals/referEarnIcon.svg');
const ICON_SIZE = 20;

const ReferEarnIcon = ({ className, style }) => (
  <img
    className={className}
    style={style}
    src={REFER_EARN_ICON_SRC}
    alt=""
    width={ICON_SIZE}
    height={ICON_SIZE}
  />
);

export default ReferEarnIcon;
